var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 0.5,
    width: 25,
    height: 25,
    rx: 12.5,
    transform: "matrix(-1 0 0 1 25 0)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 0.5,
    width: 25,
    height: 25,
    rx: 12.5,
    transform: "matrix(-1 0 0 1 25 0)",
    stroke: "#E1E6EF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4402 8.31522L10.0652 12.6902C10.0245 12.7309 9.99228 12.7791 9.97026 12.8322C9.94824 12.8853 9.93691 12.9423 9.93691 12.9998C9.93691 13.0573 9.94824 13.1142 9.97026 13.1673C9.99228 13.2204 10.0245 13.2687 10.0652 13.3093L14.4402 17.6843C14.5223 17.7664 14.6337 17.8125 14.7498 17.8125C14.8659 17.8125 14.9772 17.7664 15.0593 17.6843C15.1414 17.6022 15.1875 17.4909 15.1875 17.3748C15.1875 17.2587 15.1414 17.1473 15.0593 17.0652L10.9933 12.9998L15.0593 8.93429C15.0999 8.89364 15.1322 8.84538 15.1542 8.79227C15.1762 8.73916 15.1875 8.68224 15.1875 8.62476C15.1875 8.56727 15.1762 8.51035 15.1542 8.45724C15.1322 8.40413 15.0999 8.35587 15.0593 8.31522C15.0186 8.27458 14.9704 8.24233 14.9173 8.22033C14.8642 8.19834 14.8072 8.18701 14.7498 8.18701C14.6923 8.18701 14.6353 8.19834 14.5822 8.22033C14.5291 8.24233 14.4809 8.27458 14.4402 8.31522Z",
    fill: "#334155"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/Arrow Back.3fab2b6626602bd8eb260e174b12bb7a.svg";
export { ForwardRef as ReactComponent };